function errorNodeParser() {
    return "no node parser found";
  }
  function parseXMLToObject(node, nodeParsers) {
    let { childNodes } = node;
    let nodeCount = childNodes.length;
    let parsedNode = {};
    for (var i = 0; i < nodeCount; i++) {
      let childNode = childNodes[i];
      let { tagName } = childNode;
      if (!tagName) {
        continue;
      }
      let parser = selectNodeParser(childNode, nodeParsers);
      let nodeObj = parser(childNode, nodeParsers);
      if (parsedNode[tagName]) {
        if (!Array.isArray(parsedNode[tagName])) {
          let tagArray = [];
          tagArray.push(parsedNode[tagName]);
          parsedNode[tagName] = tagArray;
        }
        parsedNode[tagName].push(nodeObj);
      } else {
        parsedNode[tagName] = nodeObj;
      }
    }
    return parsedNode;
  }

  function parseNodeToTypeArray(node,parsers){

    let { childNodes } = node;
    let nodeCount = childNodes.length;
    let typeArray = [];
    for (var i = 0; i < nodeCount; i++) {
      let childNode = childNodes[i];
      let { tagName } = childNode;
      if (!tagName) {
        continue;
      }
      let parser = selectNodeParser(childNode, parsers);
      let nodeObj = parser(childNode, parsers);
      typeArray.push(nodeObj);
    }
    return typeArray;
  }
  function selectNodeParser(node, parsers) {
    if(!node){
      console.error('null node');
      return ()=>{ return ''};
    }
    let { tagName } = node;
    for (var i = 0; i < parsers.length; i++) {
      let { parser, tags } = parsers[i];
      if (tags.indexOf(tagName) > -1) {
        return parser;
      }
    }
  
    if (node.childNodes) {
      if (node.childNodes.length > 0) {
        return parseXMLToObject;
      }
    }
    return errorNodeParser;
  }

  function parseNodeAsText(node) {
    return node.textContent;
  }
  function parseAsFloat(node) {
    return parseFloat(node.textContent);
  }
  function parseWinnerAttributes(node) {
    return {
      name: node.getAttribute("name"),
      region: node.getAttribute("region"),
      rank: parseFloat(node.getAttribute("rank")),
    };
  }
  function parseGradeLowScale(node) {
    return {
      a: parseFloat(node.getAttribute("a")),
      b: parseFloat(node.getAttribute("b")),
      c: parseFloat(node.getAttribute("c")),
      d: parseFloat(node.getAttribute("d")),
      f: parseFloat(node.getAttribute("f")),
    };
  }
  

  const schoolXMLParser = {
    selectNodeParser: selectNodeParser,
    parsers: [
    {
        tags:['content','winners','document'],
        parser:parseNodeToTypeArray
    },
      {
        tags: ['row', 'note'],
        parser: parseXMLToObject,
      },
      {
        tags: ['top_title', 'side_title','about_title','about_text','school_type','school','division','system','district','VA_Read','VA_Math','VA_Sci','VA_SS','FRL'],
        parser: parseNodeAsText,
      },
      {
        tags: ['state_avg', 'high', 'low', 'minimum_growth','district','score','norm_score','no_score','GPA','LitNum'],
        parser: parseAsFloat,
      },
      {
        tags: ['winner'],
        parser: parseWinnerAttributes,
      },
      {
        tags: ['grade_low_scale'],
        parser: parseGradeLowScale,
      },
    ],
  };
  
  export default schoolXMLParser;
  